import { CacheRepo } from "./CacheRepo";

export class StringCacheRepo extends CacheRepo<string> {

    constructor() {
        super();
    }

    async get(key: string): Promise<string | null> {
        const cached = await super.get(key);
        return cached ? JSON.parse(cached) : null;
    }

    async set(key: string, data: string, ttl?: number): Promise<void> {
        await super.set(key, data, ttl);
    }

    async update(key: string, data: string, ttl?: number): Promise<void> {
        await super.update(key, data, ttl);
    }
}